export default __webpack_public_path__ + "static/media/csvFileHandlerLogo.4767561c.png";